<template>
  <div style="margin: 4px 16px 16px;">
    <p style="margin-bottom: 16px; font-weight: bold">累计消费次数: {{preBookNum}}</p>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="shopName" label="服务门店"/>
      <el-table-column property="showTime" label="服务时间"/>
      <el-table-column property="" label="服务类型">
        <template #default="scope">
          {{scope.row.projectServiceType == 1?'洗澡项目':scope.row.projectServiceType == 2?'增值项目':scope.row.projectServiceType == 3?'物品销售':scope.row.projectServiceType == 4?'活体销售':scope.row.projectServiceType == 5?'其他':scope.row.projectServiceType == 6?'猫咪接送':''}}
        </template>
      </el-table-column>
      <el-table-column property="name" label="服务项目"/>
      <el-table-column property="operateAdminName" label="负责人" />
      <el-table-column property="remark" label="备注" class-name="cursor"/>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getPetProjectOnePageList, statPetProjectOneNum} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import CashbackRemarkDialog from "@/views/cashback/components/CashbackRemarkDialog";
import PetProjectOneRemarkDialog from "@/views/user/components/PetProjectOneRemarkDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      id: this.value.id,
      pageDataList: [],
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      preBookNum: 0

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage(reset) {
      this.btnType = 0
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['petId'] = this.id;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPetProjectOnePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getStatNum() {
      getFormData(statPetProjectOneNum, {id: this.id}).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.preBookNum = data.data.preBookNum
        }
      })
    },


    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: PetProjectOneRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          close: () => {
            this.getPage()
          }
        })
      }

    },


  },
  mounted() {
    this.getPage()
    this.getStatNum()
  }
}
</script>

<style>

</style>
